<template>
    <div class="box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>授权管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true"  class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="" prop="SearchKey">
                <el-input  placeholder="请输入关键词" v-model="model.SearchKey"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button  type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button  type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%"   highlight-current-row
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="CorpID" label="CorpID" sortable width="180">
            </el-table-column>
           <el-table-column prop="Secret" label="Secret" sortable width="300">
            </el-table-column>
            <el-table-column prop="Manager" label="负责人" sortable width="200">
            </el-table-column>
            <el-table-column prop="Name" label="应用名称" sortable width="300">
            </el-table-column>
            <el-table-column prop="AuthType" label="授权方式" sortable width="200">
            </el-table-column>
            <el-table-column prop="IPList" label="IP白名单" sortable width="300">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" sortable width="200">
            </el-table-column>
            <el-table-column prop="DueTime" label="到期时间" sortable width="200">
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
        </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="model.Page"
                layout="total,prev, pager, next, jumper"
                :total="listCount"
                :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData"></edit>
    </div>
</template>

<script>
    import {GetWorkSQList,DeleteWorkSQ} from '../../api/authorize'
    import add from './add'
    import edit from './edit'
    export default {
        components: {
            add,
            edit
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: ''
                },
            }
        },
        watch: {
            'model.SearchKey': {
                handler(newVal) {
                    if(newVal === '') {
                        this.model.SearchKey = '';
                        this.GetWorkSQList();
                    }
                }
            }
        },
        filters: {
            filterLogo(logo) {
                if(logo) {
                    return logo.split()
                }
            },
            filterImgs(images) {
                if(typeof(images)==='string') {
                    if(images.indexOf('|')!=-1) {
                        return images.split('|');
                    }else{
                        return images.split(' ');
                    }  
                }
            }
        },
        mounted() {
            this.GetWorkSQList();
        },
        methods: {
            GetWorkSQList() {
                GetWorkSQList(this.model).then(data=>{
                    if(!data.iserror) {
                        let dataList = data.data.List;
                        dataList.forEach(item=>{
                            if(item.AuthType === 1) {
                                item.AuthType = '永久授权'
                            }else if(item.AuthType === 2) {
                                item.AuthType = '限时授权'
                            }
                        })
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetWorkSQList();
            },
            handleSearch() {
                if(this.model.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.model.Page = 1;
                this.GetWorkSQList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteWorkSQ(id);
                })
            },
            handleCloseAdd() {
                this.isShowAdd = false; 
                this.GetWorkSQList();
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetWorkSQList();
            },
            DeleteWorkSQ(id) {
                DeleteWorkSQ({OID: id}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetWorkSQList();
                    }
                })
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
        }
    }
</script>

<style>
.el-icon-circle-close:before {
    color: #ffffff;
}
</style>